import React from "react";
import ReCAPTCHA, { ReCAPTCHAProps } from "react-google-recaptcha";

interface IProps {
  onChange: ReCAPTCHAProps["onChange"];
  reCaptchaRef: React.RefObject<ReCAPTCHA>;
  siteKey: ReCAPTCHAProps["sitekey"];
}

const ReCaptchaView: React.FC<IProps> = ({
  onChange,
  reCaptchaRef,
  siteKey
}) => <ReCAPTCHA onChange={onChange} ref={reCaptchaRef} sitekey={siteKey} />;

export default ReCaptchaView;
